import { Enum } from '@/mf_lib';

var IDCardType = new Enum({
    IDCard: 'ic', // 주민등록증
    DriversLicense: 'dl', // 운전면허증
    Passport: 'pp', // 여권
});

export { IDCardType };
